import { motion } from 'framer-motion'
import { FileText, Smartphone, Link as LinkIcon, Rocket } from 'lucide-react'

const processSteps = [
  {
    icon: FileText,
    title: 'Бриф и анализ',
    description: 'Собираем требования, изучаем бизнес-процессы и формируем техническое задание',
    duration: '1-2 дня'
  },
  {
    icon: Smartphone,
    title: 'Прототип в боте',
    description: 'Создаём рабочий прототип основных сценариев для согласования логики',
    duration: '3-5 дней'
  },
  {
    icon: LinkIcon,
    title: 'Интеграции и тесты',
    description: 'Подключаем CRM, платежи, настраиваем воронки и проводим тестирование',
    duration: '5-10 дней'
  },
  {
    icon: Rocket,
    title: 'Запуск и поддержка',
    description: 'Выводим бот в продакшен, обучаем команду и обеспечиваем техподдержку',
    duration: 'от 1 месяца'
  }
]

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Процесс запуска
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Прозрачная схема работы от идеи до запуска в производство
          </p>
        </motion.div>

        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-purple-200 to-pink-200 transform -translate-y-1/2 z-0" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {processSteps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="relative"
              >
                {/* Step number */}
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg z-20">
                  {index + 1}
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 mt-8">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-xl flex items-center justify-center mb-6 mx-auto">
                    <step.icon className="w-8 h-8 text-blue-600" strokeWidth={2} />
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                    {step.title}
                  </h3>

                  <p className="text-gray-600 text-center mb-4 leading-relaxed">
                    {step.description}
                  </p>

                  <div className="text-center">
                    <span className="inline-block px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium">
                      {step.duration}
                    </span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-16 text-center"
        >
          <p className="text-lg text-gray-600">
            Полный цикл от брифа до запуска занимает от <span className="font-bold text-blue-600">2 до 4 недель</span>
          </p>
        </motion.div>
      </div>
    </section>
  )
}
